<div
  id="main-content"
  [class.top-sidebar]="themeOptions?.sidebarPosition === 'top'"
  [class.right-sidebar]="themeOptions?.sidebarPosition === 'right'"
>
  <!-- * LEFT NAVBAR -->
  <app-sidebar></app-sidebar>

  <!-- * MAIN CONTENT -->
  <div class="content relative">
    <!-- * TOP HEADER -->
    <app-header></app-header>
    <div class="main-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
